module.exports = __webpack_public_path__ + "img/10.311ebef2.jpg";